import { Cross2Icon } from "@radix-ui/react-icons";
import { Table } from "@tanstack/react-table";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import Cookies from "js-cookie";

import { Button } from "@/components/ui/button/button";
import { DataTableViewOptions } from "./data-table-view-options";
import { getAllEmployeesQueryOptions } from "@/config/queries/query-options";
import { DataTableFacetedFilter } from "./data-table-faceted-filter";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover/popover";
import { Calendar } from "@/components/ui/calendar/calendar";
import { Separator } from "@/components/ui/separator/separator";
import { format } from "date-fns";
import { Badge } from "@/components/ui/badge/badge";
import { FaUser } from "react-icons/fa6";
import { Timer } from "lucide-react";

// import { DataTableFacetedFilter } from "./data-table-faceted-filter";

interface DataTableToolbarProps<TData> {
  table: Table<TData>;
}

export function DataTableToolbar<TData>({
  table,
}: DataTableToolbarProps<TData>) {
  const isFiltered = table.getState().columnFilters.length > 0;

  const user = Cookies.get("key") as string;

  const { data, isPending, isFetching } = useQuery(
    getAllEmployeesQueryOptions(user)
  );

  const employeesData = useMemo(() => {
    if (isPending || isFetching) {
      return [];
    }

    if (data === undefined || data?.employees === undefined) {
      return [];
    }
    const tempResult = data?.employees?.filter((item) => !item.blocked);

    const result = tempResult?.map((emp) => {
      return {
        label: emp?.name,
        value: emp?.name,
      };
    });

    return result;
  }, [data, isPending, isFetching]);

  const createdAtFilterValue = table
    ?.getColumn("createdAt")
    ?.getFilterValue() as Date;

  return (
    <div className="flex items-center justify-between">
      <div className="flex flex-1 items-center space-x-2">
        {/* <Input
          placeholder="Filter by leave type..."
          value={
            (table.getColumn("leaveType")?.getFilterValue() as string) ?? ""
          }
          onChange={(event) =>
            table.getColumn("leaveType")?.setFilterValue(event.target.value)
          }
          className="h-8 w-[150px] lg:w-[250px]"
        /> */}

        {table.getColumn("employeeName") && (
          <DataTableFacetedFilter
            Icon={FaUser}
            column={table.getColumn("employeeName")}
            title="Employee"
            options={employeesData}
          />
        )}

        <Popover>
          <PopoverTrigger asChild>
            <Button variant="outline" size="sm" className="h-8 border-dashed">
              <Timer className="mr-2 h-4 w-4" />
              Date
              {createdAtFilterValue && (
                <>
                  <Separator orientation="vertical" className="mx-2 h-4" />
                  <Badge
                    variant="secondary"
                    className="rounded-sm px-1 font-normal"
                  >
                    {format(new Date(createdAtFilterValue), "PPP")}
                  </Badge>
                </>
              )}
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-[250px] p-0" align="start">
            <Calendar
              mode="single"
              selected={
                (table.getColumn("createdAt")?.getFilterValue() as Date) ??
                undefined
              }
              onSelect={(day) => {
                table.getColumn("createdAt")?.setFilterValue(day);
              }}
            />
          </PopoverContent>
        </Popover>
        {/* {table.getColumn("priority") && (
          <DataTableFacetedFilter
            column={table.getColumn("priority")}
            title="Priority"
            options={priorities}
          />
        )} */}
        {isFiltered && (
          <Button
            variant="ghost"
            onClick={() => table.resetColumnFilters()}
            className="h-8 px-2 lg:px-3"
          >
            Reset
            <Cross2Icon className="ml-2 h-4 w-4" />
          </Button>
        )}
      </div>

      <DataTableViewOptions table={table} />
    </div>
  );
}
